import Component from "@ember/component"
import { inject as service } from "@ember/service"
import type EmberStore from "cc-frontend/services/ember-store"
import { tracked } from "tracked-built-ins"

export default class AdminSidebarCardStack extends Component {
  @service("ember-store") declare store: EmberStore

  @tracked canShowActionMenu = false
}
